import { baseApi } from "@/Redux/api/baseApi";

const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEpisode: builder.query({
      query: (limit) => ({
        url: `/public/podcast/episode/view?limit=${limit}`,
        method: "GET",
      }),
    }),

   
  }),
});

export const { 
    useGetAllEpisodeQuery
 } = categoryApi;
